import { createSelector } from 'reselect'

export const getConfiguration = state => state.configuration

export const getServerUrl = createSelector(
    getConfiguration,
    configuration => `${configuration.location.server}`,
)

export const getMediaBatchSize = createSelector(
    getConfiguration,
    configuration => configuration.media.batchSize,
)

export const getMediaThreshold = createSelector(
    getConfiguration,
    configuration => configuration.media.threshold,
)

export const getMediaJumpStep = createSelector(
    getConfiguration,
    configuration => configuration.media.jumpStep,
)

export const isMediaInfoFeatureEnable = createSelector(
    getConfiguration,
    configuration => configuration.features.mediaInfo
)

export const getFetchMediaDebounceWait = createSelector(
    getConfiguration,
    configuration => configuration.media.debounceWait,
)

export const getDevicesBreakPoints = createSelector(
    getConfiguration,
    configuration => configuration.visualizer.devices.breakPoints
)

export const getLargeDevicesBreakPoint = createSelector(
    getDevicesBreakPoints,
    devicesBreakPoints => devicesBreakPoints.large
)

export const getMediumDevicesBreakPoint = createSelector(
    getDevicesBreakPoints,
    devicesBreakPoints => devicesBreakPoints.medium
)

export const getCollaborativeIndexation = createSelector(
    getConfiguration,
    configuration => configuration.collaborativeIndexation,
)
